import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import WorkspacePageTemplate from "../common/WorkspacePageTemplate";
import AccountPanel from "./account/AccountsPanel";
import MembersPanel from "./members/MembersPanel";
import WalkthroughsPanel from "./walkthroughs/WalkthroughsPanel";
import PlatformPanel from "./platform/PlatformPanel";
import { useProfile } from "../../context/ProfileContext";
import { colors, buttons } from "../../styles/index";

// Settings (logistics-workflow's workspace page with a left nav): the account, the org's members, the walkthroughs, and -
// for the platform admin only - every org.
const SECTIONS = [
  { key: "account", label: "Account" },
  { key: "members", label: "Members" },
  { key: "walkthroughs", label: "Walkthroughs" },
  { key: "platform", label: "Platform", adminOnly: true },
];

export default function SettingsPage({ logout }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const { profile } = useProfile();
  const visible = SECTIONS.filter((s) => !s.adminOnly || profile?.role === "admin");
  const wanted = searchParams.get("section");
  const [section, setSection] = useState(visible.some((s) => s.key === wanted) ? wanted : "account");

  useEffect(() => {
    if (wanted && visible.some((s) => s.key === wanted)) setSection(wanted);
  }, [wanted]); // eslint-disable-line react-hooks/exhaustive-deps

  const choose = (key) => { setSection(key); setSearchParams({ section: key }, { replace: true }); };

  const sidebar = visible.map((s) => {
    const active = section === s.key;
    return (
      <button
        key={s.key}
        id={`${s.key}LeftNavSettings`}
        type="button"
        onClick={() => choose(s.key)}
        style={{ ...buttons.secondary, width: "100%", justifyContent: "flex-start", marginBottom: 6,
          background: active ? colors.primarySoft : "transparent", color: active ? colors.primary : colors.textDark,
          fontWeight: active ? 600 : 500 }}
      >
        {s.label}
      </button>
    );
  });

  return (
    <WorkspacePageTemplate title="Settings" sidebar={sidebar}>
      {section === "account" && <AccountPanel logout={logout} />}
      {section === "members" && <MembersPanel />}
      {section === "walkthroughs" && <WalkthroughsPanel />}
      {section === "platform" && <PlatformPanel />}
    </WorkspacePageTemplate>
  );
}
